export class Nacionalidade {
  idNacionalidade: number = null;
  dsNacionalidade: string = null;

  constructor(d?) {
    if (d) {
      this.idNacionalidade = d.idNacionalidade ? d.idNacionalidade : null;
      this.dsNacionalidade = d.dsNacionalidade ? d.dsNacionalidade : null;
    }
  }
}
